// src/utils/logout.js
// Déconnexion propre : vide localStorage + IndexedDB (queue offline)
// Note : Le cache API du SW ne contient AUCUNE donnée personnelle (voir service-worker.js)
//        Donc pas besoin de le purger au logout.

import { clearQueue } from './offlineQueue';

export const performLogout = async () => {
    console.log('🚪 [logout] Déconnexion en cours...');

    // 1. Vider la file d'attente offline (IndexedDB)
    try {
        await clearQueue();
        console.log('🧹 [logout] File d\'attente vidée');
    } catch (err) {
        console.warn('⚠️ [logout] Purge queue échouée:', err.message);
    }

    // 2. Vider le localStorage + sessionStorage
    // 🆕 PHASE THEME : sauvegarder les clés theme_* avant le clear
    try {
        const themeBackup = {};
        Object.keys(localStorage).forEach((key) => {
            if (key.startsWith('theme_')) {
                themeBackup[key] = localStorage.getItem(key);
            }
        });

        localStorage.clear();
        sessionStorage.clear();

        // 🆕 PHASE THEME : restaurer les préférences de thème (par utilisateur)
        Object.entries(themeBackup).forEach(([key, value]) => {
            localStorage.setItem(key, value);
        });

        console.log('🧹 [logout] localStorage + sessionStorage vidés (thèmes préservés)');
    } catch (err) {
        console.warn('⚠️ [logout] Purge storage échouée:', err.message);
    }

    // 🆕 PHASE THEME : notifier le ThemeContext du changement d'utilisateur
    window.dispatchEvent(new Event('user:changed'));

    console.log('✅ [logout] Déconnexion terminée');
};

export default performLogout;